// components/layouts/PublicLayout.tsx

"use client";

import Header from '../ui/Header';
import Footer from '../ui/Footer';
import "./PublicLayout.css";

const PublicLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="layout-public">
      <Header />

      <main>
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default PublicLayout;